'use strict';

exports.__esModule = true;
exports.GET_SPECIALIST_IMAGE = exports.GET_REVIEWS = undefined;

var _doctifyUtils = require('doctify-utils');

var GET_REVIEWS = exports.GET_REVIEWS = 'REVIEW_CAROUSEL:GET_REVIEWS';
var GET_SPECIALIST_IMAGE = exports.GET_SPECIALIST_IMAGE = 'REVIEW_CAROUSEL:GET_SPECIALIST_IMAGE';

var reviewCarouselActions = {
	getReviews: function getReviews(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'reviews',
			method: 'GET',
			parameters: {
				min_rating: 5,
				profile_type: 'specialist',
				random: 'true',
				limit: 6,
				status_filter: 'approved',
				verified_filter: true,
				profile_images_required: true,
				review_body_required: true
			},
			actionType: GET_REVIEWS,
			xhrConfig: xhrConfig
		});
	},
	getSpecialistImage: function getSpecialistImage(specialistId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId,
			method: 'GET',
			actionType: GET_SPECIALIST_IMAGE,
			xhrConfig: xhrConfig
		});
	}
};

exports.default = reviewCarouselActions;


// WEBPACK FOOTER //
// ./components/home-page/lib/actions/review-carousel.js